import { SceneExt } from './sceneExt';

/** Scene data extension. */
export const sceneExt: SceneExt = new SceneExt();

/**
 * Dispose module
 */
export function dispose() {
  sceneExt.dispose();
}
